/**
 * @flow
 * @relayHash 124b105b68a3d430b2728bd5f2a5a83f
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type GuestSquareBoard_getFrontGuestSquareBoardData$ref = any;
export type GuestSquareBoardefetchQueryVariables = {|
  event_token: string,
  guest_token: string,
  game_id: string,
  question_id: string,
|};
export type GuestSquareBoardefetchQueryResponse = {|
  +$fragmentRefs: GuestSquareBoard_getFrontGuestSquareBoardData$ref
|};
export type GuestSquareBoardefetchQuery = {|
  variables: GuestSquareBoardefetchQueryVariables,
  response: GuestSquareBoardefetchQueryResponse,
|};
*/


/*
query GuestSquareBoardefetchQuery(
  $event_token: String!
  $guest_token: String!
  $game_id: ID!
  $question_id: ID!
) {
  ...GuestSquareBoard_getFrontGuestSquareBoardData_4qcSXL
}

fragment GuestSquareBoard_getFrontGuestSquareBoardData_4qcSXL on Query {
  getFrontGuestSquareBoardData(event_token: $event_token, guest_token: $guest_token, game_id: $game_id, question_id: $question_id) {
    code
    message
    data {
      _id
      guest_name
      allowed_squares
      number_of_selected_squares
      responses {
        _id
        square
        guest_id
      }
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "event_token",
    "type": "String!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "guest_token",
    "type": "String!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "game_id",
    "type": "ID!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "question_id",
    "type": "ID!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "event_token",
    "variableName": "event_token"
  },
  {
    "kind": "Variable",
    "name": "game_id",
    "variableName": "game_id"
  },
  {
    "kind": "Variable",
    "name": "guest_token",
    "variableName": "guest_token"
  },
  {
    "kind": "Variable",
    "name": "question_id",
    "variableName": "question_id"
  }
],
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "_id",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "GuestSquareBoardefetchQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "FragmentSpread",
        "name": "GuestSquareBoard_getFrontGuestSquareBoardData",
        "args": (v1/*: any*/)
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "GuestSquareBoardefetchQuery",
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "getFrontGuestSquareBoardData",
        "storageKey": null,
        "args": (v1/*: any*/),
        "concreteType": "frontGuestSquareBoardType",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "code",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "message",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "data",
            "storageKey": null,
            "args": null,
            "concreteType": "frontGuestSquareBoardDataType",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "guest_name",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "allowed_squares",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "number_of_selected_squares",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "responses",
                "storageKey": null,
                "args": null,
                "concreteType": "returnSquareGuestData",
                "plural": true,
                "selections": [
                  (v2/*: any*/),
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "square",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "guest_id",
                    "args": null,
                    "storageKey": null
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "operationKind": "query",
    "name": "GuestSquareBoardefetchQuery",
    "id": null,
    "text": "query GuestSquareBoardefetchQuery(\n  $event_token: String!\n  $guest_token: String!\n  $game_id: ID!\n  $question_id: ID!\n) {\n  ...GuestSquareBoard_getFrontGuestSquareBoardData_4qcSXL\n}\n\nfragment GuestSquareBoard_getFrontGuestSquareBoardData_4qcSXL on Query {\n  getFrontGuestSquareBoardData(event_token: $event_token, guest_token: $guest_token, game_id: $game_id, question_id: $question_id) {\n    code\n    message\n    data {\n      _id\n      guest_name\n      allowed_squares\n      number_of_selected_squares\n      responses {\n        _id\n        square\n        guest_id\n      }\n    }\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'b781104434d4f7b9fc288a61a19b9682';
module.exports = node;
